export default __webpack_public_path__ + "static/media/dtms-intro.01878d62.jpg";